import type { TravelStoryEnvelope } from "@/types/travel-story"

import { baseApi } from "./base-api"

export const travelStoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTravelStory: builder.query<TravelStoryEnvelope, void>({
      query: () => ({ url: "/api/google_calendar/travel_story" }),
      providesTags: ["TravelStory"],
    }),
  }),
})

export const { useGetTravelStoryQuery } = travelStoryApi
